var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiscellaneous(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 14.5V21.5H9.5V14.5H2.5ZM2 13C1.44772 13 1 13.4477 1 14V22C1 22.5523 1.44772 23 2 23H10C10.5523 23 11 22.5523 11 22V14C11 13.4477 10.5523 13 10 13H2Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.25C0.999979 9.83579 1.33582 9.50022 1.75004 9.5002L5.5 9.50004L5.50002 5.75C5.50002 5.33578 5.83581 5 6.25002 5H9.5L9.50079 1.74981C9.50089 1.3356 9.83676 0.999897 10.251 1C10.6652 1.0001 11.0009 1.33597 11.0008 1.75019L10.9998 5.75019C10.9997 6.16433 10.664 6.5 10.2498 6.5H7.00002L7 10.25C6.99999 10.6642 6.66423 11 6.25003 11L1.75004 11C1.33582 11 1.00002 10.6642 1 10.25Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.5C19.933 9.5 21.5 7.933 21.5 6C21.5 4.067 19.933 2.5 18 2.5C16.067 2.5 14.5 4.067 14.5 6C14.5 7.933 16.067 9.5 18 9.5ZM18 11C20.7614 11 23 8.76142 23 6C23 3.23858 20.7614 1 18 1C15.2386 1 13 3.23858 13 6C13 8.76142 15.2386 11 18 11Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.2117L14.8029 21.5H21.1971L18 15.2117ZM18.8256 13.5258C18.4691 12.8247 17.5309 12.8247 17.1744 13.5258L13.1162 21.508C12.7743 22.1803 13.2279 23 13.9417 23H22.0583C22.7721 23 23.2257 22.1803 22.8838 21.508L18.8256 13.5258Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneous);
export default __webpack_public_path__ + "static/media/Miscellaneous.2b39e632504feab027500a2ccf0bc301.svg";
export { ForwardRef as ReactComponent };